<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
    >
        <template v-slot:[`item.name`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.item_group.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.name}}
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "ItemGroupList",
    data() {
        return {
            headers: [
                { text: "Item Group", value: "name" },
                { text: "Code", value: "code" },
                { text: "Parent Group", value: "parent"}
            ],
            footer: {
                'items-per-page-options': [5, 10, 15]
            },
            perm: permissions
        }
    },
    computed : {
        ...mapGetters({
            list: "stock/itemGroup/list/data",
            options: "stock/itemGroup/list/options",
            loading: "stock/itemGroup/list/loading",
            length: "stock/itemGroup/list/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "stock/itemGroup/list/updateOptions",
            updateParams: "stock/itemGroup/list/updateParams",
        }),
        handleClickRow(item){  
            // this.updateParams({parent_id: item.id})
            this.$router.push({ name: 'ItemGroupDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>
</style>